import React from 'react';
import ChatBot, { Flow } from 'react-chatbotify';
import LlmConnector from '@rcb-plugins/llm-connector';
import CustomProxyProvider from "@/ai-chat/CustomProxyProvider";
// Import CustomProxyProvider (z bodu 1)


const toolsDefinition = [];

const MyChatbot = () => {
    const primary = "#0F4C75";

    // Instance Provideru, který komunikuje s vaším backendem
    const customProvider = new CustomProxyProvider((window.aiChatServerUrl || 'https://aipanel.propujcovny.cz').replace(/\/$/, ''));

    const flow = {
        start: {
            message: "Vítejte! Zeptejte se na cokoli, nebo mi řekněte, co chcete koupit.",
            transition: 0,
            path: "llm_conversation_loop",
        },

        // Krok, který předává veškerou konverzaci LLM
        llm_conversation_loop: {
            llmConnector: {
                provider: customProvider, // Váš custom provider
                tools: toolsDefinition,     // Definice Toolů
                // Tato vlastnost říká, že se má volat zpět na "llm_conversation_loop"
                // a pokračovat v konverzaci s LLM
                path: "llm_conversation_loop",
            },
        },
    };

    const themes = [
        {id: "Simple_blue", version: "0.1.0"}
    ]

    const styles = {
        "headerStyle": {
            "backgroundImage": '',
            "backgroundColor": primary,
            "color": "#fff",
            "textShadow": "none"
        },
        "chatWindowStyle": {
            "backgroundColor": "#f9fafb"
        },
        "chatIconStyle": {
            "backgorundImage": "",
            "backgroundColor": primary,
            "backgroundSize": "40px",

        },
        "botBubbleStyle": {
            "textAlign": "left",
            "color": "#334155",
            "borderRadius": "12px 12px 12px 0",
            "backgroundImage": '',
            "backgroundColor": "#e5e7eb",
            "padding": ""
        },
        "userBubbleStyle": {
            "backgroundColor": primary,
            "color": "#ffffff",
            "borderRadius": "8px 8px 0 8px"
        },
        "chatInputContainerStyle": {
            "backgroundColor": "#e5e7eb"
        },
        "chatInputAreaStyle": {
            "minHeight": 0,
            "border": 0,
            "padding": "8px 15px",
            "backgroundColor": "white",
            "color": "#334155",
            "fontSize": "14px",
            "outlineColor": "transparent"
        },
        "sendButtonStyle": {
            "display": "none"
        },
        "chatHistoryButtonStyle": {
            "color": "#6b7280",
            "backgroundColor": "white",
            "border": "1px solid #e5e7eb"
        },
        "chatHistoryButtonHoveredStyle": {
            "color": "#3b82f6",
            "backgroundColor": "white",
            "border": "1px solid #3b82f6"
        },
        "tooltipStyle": {
            "padding": "8px 12px",
            "borderRadius": "15px",
            "color": "white",
            "backgroundImage": null,
            "backgroundColor": primary,
        },
        "botOptionStyle": {
            "color": "#6b7280",
            "backgroundColor": "white",
            "border": "1px solid #e5e7eb"
        },
        "botOptionHoveredStyle": {
            "color": "#3b82f6",
            "backgroundColor": "transparent",
            "border": "1px solid #3b82f6",
            "boxShadow": "none"
        },
        "botCheckboxRowStyle": {
            "color": "#6b7280",
            "backgroundColor": "white",
            "border": "1px solid #e5e7eb",
            "borderRadius": "6px",
            "boxShadow": "none"
        },
        "botCheckboxNextStyle": {
            "color": "#6b7280",
            "backgroundColor": "white",
            "border": "1px solid #e5e7eb",
            "borderRadius": "6px",
            "boxShadow": "none"
        },
        "botCheckMarkSelectedStyle": {
            "backgroundColor": "#3b82f6"
        },
        "loadingSpinnerStyle": {
            "borderTop": "4px solid #3b82f6"
        }
    }
;

    const settings = {
        "chatInput": {
            "enabledPlaceholderText": "Dotaz na AI.."
        },
        "notification": {
            "disabled": true
        },
        "general": {
            "primaryColor": "#5BC6E6",
            "secondaryColor": "#daedf2",
            "showFooter": false
        },
        "header": {
            "showAvatar": false,
            "title": "AI Asistant"
        },
        "tooltip": {
            "text": "AI Asistant",
        },
        chatButton: {
            "icon": "images/aichat.png"
        }
    };



    return (
        <ChatBot
            flow={flow}
            styles={styles}
            settings={settings}
            plugins={[LlmConnector()]} // Inicializace pluginu
        />
    );
};

export default MyChatbot;